import { CommunicatorService } from 'ui-ng-component-communicator';
import { CourseAlertsQuery } from './queries/course_alerts_query';

class CourseAlertsController {
  private isOpened: boolean = false;
  private openBound: () => void;

  constructor(
    private ngComponentCommunicatorService: CommunicatorService,
    private ngCourseAlertsQuery: CourseAlertsQuery
  ) {}

  $onInit() {
    this.openBound = this.openCourseAlertsDrawer.bind(this);
    this.ngComponentCommunicatorService.subscribe('OPEN_COURSE_ALERTS_MODAL', this.openBound);
  }

  $onDestroy() {
    this.ngComponentCommunicatorService.release('OPEN_COURSE_ALERTS_MODAL', this.openBound);
  }

  openCourseAlertsDrawer() {
    this.isOpened = true;
  }

  closeCourseAlertsDrawer() {
    this.isOpened = false;
  }
}

class CourseAlertsComponent implements ng.IComponentOptions {
  public bindings: ng.IComponentOptions['bindings'];
  public controller: ng.IComponentOptions['controller'];
  public templateUrl: ng.IComponentOptions['templateUrl'];
  constructor() {
    this.bindings = {};
    this.controller = CourseAlertsController;
    this.templateUrl = 'capability-ng-scheduler/src/components/course_alerts/course_alerts.html';
  }
}

angular.module('capability-ng-scheduler').component('courseAlerts', new CourseAlertsComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/course_alerts/course_alerts.ts